var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right",style:({
	backgroundImage: 'url(' + _vm.bgImg + ')',
	backgroundSize: _vm.size,
	animationDuration: _vm.speed + 's',
	height: _vm.height,
	animationName: _vm.right ? ("background-move-left-" + (this.$options._scopeId)) : ("background-move-right-" + (this.$options._scopeId))
})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277d45a9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/objects/misc/ScrollingObject.vue
// module id = 65
// module chunks = 0